module.exports = __webpack_public_path__ + "img/add-arrival-canceled-climbing-table-icon.d4da6558.svg";